import React from "react";

export function ModalShell({
                               title,
                               subtitle,
                               children,
                               onClose,
                           }: {
    title: string;
    subtitle?: string;
    children: React.ReactNode;
    onClose: () => void;
}) {
    return (
        <div className="profile-modal-overlay" onMouseDown={onClose}>
            <div className="profile-modal" onMouseDown={(e) => e.stopPropagation()}>
                <div className="profile-modal-head">
                    <div>
                        <div className="profile-modal-title">{title}</div>
                        {subtitle && <div className="profile-modal-subtitle">{subtitle}</div>}
                    </div>
                    <button className="profile-modal-close" onClick={onClose} aria-label="Закрыть">
                        ✕
                    </button>
                </div>
                <div className="profile-modal-body">
                    {children}
                </div>
            </div>
        </div>
    );
}
